class CelectOptionController {
  constructor($element) {
    this.$element = $element;
  }

  $postLink() {
    this.$element.addClass('celect-option');
  }
}

CelectOptionController.$inject = ['$element'];
export default CelectOptionController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/components/celect/celect-option.controller.js